/** Opens one Purchases section from outside it (for example an expense claim
 * row in Home "Coming up"). PurchasesView is lazily loaded, so a section
 * request sent while it is unmounted has no listener. The request is parked
 * here and read when the hub mounts, and also sent live for the case where it
 * is already open.
 *
 * It lapses after REQUEST_TTL_MS (long enough for a slow chunk load) and
 * browser Back or Forward drops it, so a stale request cannot hijack a later
 * visit to Purchases.
 */
const REQUEST_TTL_MS = 30_000;

let pending: { sectionId: string; at: number } | null = null;

export function clearRequestedPurchasesSection(): void {
  pending = null;
}

export function takeRequestedPurchasesSection(now: number = Date.now()): string | null {
  const request = pending;
  pending = null;
  return request && now - request.at <= REQUEST_TTL_MS ? request.sectionId : null;
}

export function openPurchasesSection(sectionId: string): void {
  pending = { sectionId, at: Date.now() };
  window.addEventListener('popstate', clearRequestedPurchasesSection, { once: true });
  window.dispatchEvent(new CustomEvent('app:navigate', { detail: { view: 'purchases' } }));
  window.dispatchEvent(new CustomEvent('purchases:navigate-section', { detail: { sectionId } }));
}
